import { render, staticRenderFns } from "./TabExport.vue?vue&type=template&id=530be881&"
import script from "./TabExport.vue?vue&type=script&lang=js&"
export * from "./TabExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports